/* app/js/src/components/common/wizard/wizard-summary.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  background-color: #eef2f6;
  padding: 2vh 40px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
}
.step {
  margin-left: 89px;
  margin-bottom: 6vh;
  position: relative;
}
.step:first-of-type {
  margin-top: 15px;
}
.step header {
  position: relative;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: #879baf;
}
.step header .step-icon {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  border: 1px solid #dde3e7;
  position: absolute;
  top: calc(66px / 2);
  left: calc(-66px - 23px);
  transform: translate(0, -50%);
  background-color: #eef2f6;
}
.step header .step-icon i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  height: 40%;
}
.step header .step-icon i ::ng-deep svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}
.step header .step-icon i ::ng-deep svg path,
.step header .step-icon i ::ng-deep svg polygon {
  fill: #879baf !important;
  -webkit-transition: all 0.3s cubic-bezier(0.44, 0.01, 0.04, 0.94);
  transition: all 0.3s cubic-bezier(0.44, 0.01, 0.04, 0.94);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.step header .step-icon:hover i ::ng-deep svg path,
.step header .step-icon:hover i ::ng-deep svg polygon {
  fill: #5d758c !important;
}
.step header label {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.69;
  display: block;
}
.step header span {
  display: block;
}
.step header label,
.step header span {
  -webkit-transition: all 0.4s cubic-bezier(0.44, 0.01, 0.04, 0.94);
  transition: all 0.4s cubic-bezier(0.44, 0.01, 0.04, 0.94);
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
}
.step.current header,
.step.done header {
  color: #232f3a;
}
.step.current header .step-icon,
.step.done header .step-icon {
  background-color: #ffffff;
  border: none;
}
.theme-purple.step.current header i ::ng-deep svg path,
.theme-purple.step.current header i ::ng-deep svg polygon,
.theme-purple.step.done header i ::ng-deep svg path,
.theme-purple.step.done header i ::ng-deep svg polygon {
  fill: #a65bfa !important;
}
.theme-purple.step.current header:hover i ::ng-deep svg path,
.theme-purple.step.current header:hover i ::ng-deep svg polygon,
.theme-purple.step.done header:hover i ::ng-deep svg path,
.theme-purple.step.done header:hover i ::ng-deep svg polygon {
  fill: #7e11f8 !important;
}
.theme-cyan.step.current header i ::ng-deep svg path,
.theme-cyan.step.current header i ::ng-deep svg polygon,
.theme-cyan.step.done header i ::ng-deep svg path,
.theme-cyan.step.done header i ::ng-deep svg polygon {
  fill: #40c4ff !important;
}
.step-body {
  font-size: 12px;
  color: #232f3a;
  letter-spacing: 0.1px;
  -webkit-transition: all 0.4s cubic-bezier(0.44, 0.01, 0.04, 0.94);
  transition: all 0.4s cubic-bezier(0.44, 0.01, 0.04, 0.94);
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
}
.step-body > div {
  margin-top: 5px;
}
.step-body > div label {
  color: #7d8fa1;
}
.step::before {
  content: "";
  width: 1px;
  background: #dde3e7;
  position: absolute;
  left: calc(-66px / 2 - 23px);
  top: 0;
  bottom: -100%;
}
.step:last-child::before {
  display: none;
}
.step:hover .step-body {
  -ms-transform: translateX(5px);
  -webkit-transform: translateX(5px);
  transform: translateX(5px);
}
.step:hover header label,
.step:hover header span {
  -ms-transform: translateX(5px);
  -webkit-transform: translateX(5px);
  transform: translateX(5px);
}
/*# sourceMappingURL=wizard-summary.component.css.map */
